import './User.css';
import { useEffect, useState } from 'react';
import { Breadcrumbs, Button, MenuItem, TextField, Typography, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
// Components
import StandardPageWrapper from '../../../components/StandardPageWrapper/StandardPageWrapper';
import ReactCustomTable from '../../../components/ReactCustomTable/ReactCustomTable';
import StandardMuiDialogWrapper from '../../../components/StandardMuiDialogWrapper/StandardMuiDialogWrapper';
import StandardOutlinedTextfield from '../../../components/StandardOutlinedTextfield/StandardOutlinedTextfield';
// ICONs & SVGs
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Delete, Edit, LockOpen, Visibility, ContentCopy } from '@mui/icons-material'
// QR Code library
import { QRCodeCanvas } from 'qrcode.react';
import { useRef } from 'react';


function User() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { state } = useLocation();
  const isVendor = sessionStorage.getItem('ID_CardAdmin_user_role') === 'vendor';
  const [searchInput, setSearchInput] = useState("");

  const [addUserData, setAddUserData] = useState({ first_name: '', phone_no: '' });
  const [allUserData, setAllUserData] = useState([]);
  const [allUserDataLoading, setAllUserDataLoading] = useState(true);

  // Dialog states
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogBtnLoading, setDialogBtnLoading] = useState(false);

  // Delete
  const [deleteID, setDeleteID] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  // Delete confirmation dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState(null);

  // Edit
  const [editActive, setEditActive] = useState(false);
  const [editData, setEditData] = useState({});

  // QR Dialog
  const [qrData, setQrData] = useState('');
  const [qrOpen, setQrOpen] = useState(false);
  const qrRef = useRef(null);
  const [qrFileName, setQrFileName] = useState("");

  // Promote Class
  const [openPromoteDialog, setOpenPromoteDialog] = useState(false);
  const [promoteData, setPromoteData] = useState({ standard: '', division: '' });
  const [promoteLoading, setPromoteLoading] = useState(false);
  const [unlockLoading, setUnlockLoading] = useState(false);

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    if (!state) return navigate(-1);
    fetchUserByClass();
  }, [page, limit, searchInput])

  const filteredUserData = allUserData.filter(user =>
    user.first_name.toLowerCase().includes(searchInput.toLowerCase()) ||
    user.phone_no.includes(searchInput)
  );

  const fetchUserByClass = async () => {
    setAllUserDataLoading(true);
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getuserbyclassid`, {
      classid: state.classid,
      page,
      limit,
      search: searchInput
    })
      .then(res => {
        if (res.data.success) {
          const users = res.data.data;
          const sortedUsers = [...users].sort((a, b) => {
            if (a.role === "teacher" && b.role !== "teacher") return -1;
            if (a.role !== "teacher" && b.role === "teacher") return 1;
            return 0;
          });
          setAllUserData(sortedUsers);
          setTotalCount(res.data.totalCount || 0);
        } else {
          enqueueSnackbar(res.data.data, { variant: 'error' });
        }
        setAllUserDataLoading(false);
      })
      .catch(err => {
        console.log(err);
        setAllUserDataLoading(false);
        enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
      });
  }

  const onEdit = (e, data) => {
    e.stopPropagation();
    setOpenDialog(true);
    setEditActive(true);
    setAddUserData({ first_name: data?.first_name, phone_no: data?.phone_no });
    setEditData(data);
  }

  const onAddUser = async () => {
    if (Object.values(addUserData)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' });

    const body = { ...addUserData, role: 'student', classid: state.classid, schoolid: state.schoolid, is_verified: 1 }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/signup`, body)
      .then(res => {
        if (res.data.success) {
          setAllUserData([...allUserData, res.data.data[0]]);
          enqueueSnackbar('User Added Successfully !!!', { variant: 'success' });
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
        setOpenDialog(false);
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
      })
  }

  const onExited = () => {
    setAddUserData({ first_name: '', phone_no: '' });
    setEditData({});
  }

  const onSaveEdit = async () => {
    if (Object.values(addUserData)?.includes("")) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' });
    if (Object.keys(editData)?.length <= 0) return enqueueSnackbar('Please Try Again !!!', { variant: 'error' });

    setDialogBtnLoading(true);
    const body = {
      user_id: editData?.id,
      first_name: addUserData?.first_name,
      last_name: editData?.last_name,
      phone_no: addUserData?.phone_no,
      email: editData?.email,
      password: editData?.password,
      role: editData?.role,
      classid: editData?.classid,
      schoolid: editData?.schoolid,
      verification_status: 1
    }

    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateuser`, body)
      .then(res => {
        if (res.data.success) {
          let arr = [...allUserData];
          let changeIndex = arr.findIndex(a => a.id == editData?.id);
          if (changeIndex !== -1) arr[changeIndex] = { ...arr[changeIndex], ...body };
          setAllUserData(arr);
          setOpenDialog(false);
          enqueueSnackbar('User Updated Successfully !!!', { variant: 'success' });
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' });
        }
        setDialogBtnLoading(false);
      })
      .catch(err => {
        console.log(err);
        enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
        setOpenDialog(false);
        setDialogBtnLoading(false);
      })
  }

  const onDeleteClick = (e, data) => {
    e.stopPropagation();
    setDeleteRowData(data);
    setOpenDeleteDialog(true);
  };

  const onDelete = async (e, data) => {
    e.stopPropagation();
    setDeleteID(data.id);
    setDeleteLoading(true);

    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/deleteuser`, { user_id: data.id })
      .then(res => {
        if (res.data.success) {
          setAllUserData(allUserData?.filter((s) => s?.id != data?.id));
          enqueueSnackbar("User Deleted Successfully !!!", { variant: "success" });
        } else {
          enqueueSnackbar("Error Deleting User, Try Again !!!", { variant: "error" });
        }
        setDeleteID("");
        setDeleteLoading(false);
      })
      .catch(err => {
        console.log(err);
        setDeleteLoading(false);
        setDeleteID("");
        enqueueSnackbar("Something Went Wrong !!!", { variant: "error" });
      });
  }

  const showQr = (e, data) => {
    e.stopPropagation();
    console.log(data);
    const phone = data.phone_no.replace(/\s+/g, "");
    const link = `https://gjaaipublication.com/login?con_mobile=${phone}`;
    setQrFileName(`${data.school[0].name}`);
    setQrData(link);
    setQrOpen(true);
  }

  const downloadQRCode = () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = `${qrFileName.replace(/[^a-z0-9]/gi, " ")}`;
    link.click();
  };

  const copyQRCode = async () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    // Full instructions text
    const instructionsText = `Step-1:

Download ID Solutions app on Playstore

OR

Click this Link:
https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication

Step-2:

Scan This QR For Login`;

    try {
      // Copy image to clipboard
      canvas.toBlob(async (blob) => {
        try {
          if (navigator.clipboard && window.ClipboardItem) {
            // Create a ClipboardItem with both image and text formats
            // Applications can choose which format to paste
            const clipboardItem = new window.ClipboardItem({
              'image/png': blob,
              'text/plain': new Blob([instructionsText], { type: 'text/plain' })
            });
            await navigator.clipboard.write([clipboardItem]);

            enqueueSnackbar('Instructions and QR Code copied to clipboard!', { variant: 'success' });
          } else {
            // Fallback: copy text only
            await navigator.clipboard.writeText(instructionsText);
            enqueueSnackbar('Instructions copied to clipboard! (Image copy not supported in this browser)', { variant: 'info' });
          }
        } catch (err) {
          console.error('Failed to copy with ClipboardItem:', err);
          // Fallback: copy text only
          await navigator.clipboard.writeText(instructionsText);
          enqueueSnackbar('Instructions copied to clipboard!', { variant: 'success' });
        }
      });
    } catch (err) {
      console.error('Failed to copy:', err);
      enqueueSnackbar('Failed to copy QR Code', { variant: 'error' });
    }
  };

  const tableActions = isVendor
    ? [
      { icon: <Visibility sx={{ cursor: "pointer", color: "#7978e9" }} />, onClick: showQr },
    ]
    : [
      { icon: <Delete sx={{ cursor: "pointer" }} color="error" />, onClick: onDelete, btnType: "del" },
      { icon: <Edit sx={{ cursor: "pointer", color: "#7978e9" }} />, onClick: onEdit },
      { icon: <Visibility sx={{ cursor: "pointer", color: "#7978e9" }} />, onClick: showQr },
    ];



  const onPromoteClass = async () => {
    if (!promoteData.standard || !promoteData.division) {
      return enqueueSnackbar('Please fill all fields', { variant: 'error' });
    }

    setPromoteLoading(true);
    try {
      // First API call to delete users
      const deleteResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/deleteByClass`, {
        classid: state.classid
      });

      if (!deleteResponse.data.success) {
        throw new Error(deleteResponse.data.message || 'Error deleting users');
      }

      // Second API call to update class
      const updateResponse = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateclass`, {
        classid: state.classid,
        is_locked: 1,
        standard: promoteData.standard,
        division: promoteData.division
      });

      if (!updateResponse.data.success) {
        throw new Error(updateResponse.data.message || 'Error updating class');
      }

      enqueueSnackbar('Class promoted successfully', { variant: 'success' });
      setOpenPromoteDialog(false);
      setPromoteData({ standard: '', division: '' });
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error.message || 'Something went wrong', { variant: 'error' });
    } finally {
      setPromoteLoading(false);
    }
  };

  const onUnlockClass = async () => {
    setUnlockLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateclass`, {
        classid: state.classid,
        is_locked: 0,
        standard: state.standard,
        division: state.division
      });

      if (response.data.success) {
        enqueueSnackbar('Class unlocked successfully', { variant: 'success' });
      } else {
        throw new Error(response.data.message || 'Error unlocking class');
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error.message || 'Something went wrong', { variant: 'error' });
    } finally {
      setUnlockLoading(false);
    }
  };

  return (
    <>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 1 }}>
        <Typography color="grey">Schools</Typography>
        <Typography color="grey">Class</Typography>
        <Typography sx={{ color: "#7978e9", fontWeight: "bold" }}>User</Typography>
      </Breadcrumbs>

      <StandardPageWrapper
        header="User"
        btns={
          isVendor ? null : (
            <>
              <Button variant="contained" onClick={() => setOpenDialog(true)}>Add Student</Button>
              <Button variant="contained" onClick={() => setOpenPromoteDialog(true)}>Promote Class</Button>
              <Button variant="contained" onClick={onUnlockClass} disabled={unlockLoading} startIcon={<LockOpen />}>Unlock Class</Button>
            </>
          )
        }
      >
        <TextField
          sx={{ marginBottom: "20px" }}
          variant="outlined"
          type="text"
          fullWidth
          placeholder="Search Users..."
          value={searchInput}
          onChange={(e) => {
            setSearchInput(e.target.value);
            setPage(1);
          }}
        />
        <div id="users">
          <ReactCustomTable
            data={allUserData}
            tableColumns={tableColumns}
            loading={allUserDataLoading}
            tableActions={tableActions}
            actionsColumnWidth={isVendor ? 50 : 180}
            deleteID={deleteID}
            deleteLoading={deleteLoading}
            rowDataDeleteKey="classid"
            circularColor="#d32f2f"
            // Pagination props
            total={totalCount}
            limit={limit}
            activePage={page}
            onChangePage={setPage}
            onChangeLimit={(l) => { setLimit(l); setPage(1); }}
          />
        </div>

        {/* Add/Edit Dialog */}
        <StandardMuiDialogWrapper
          open={openDialog}
          setOpen={setOpenDialog}
          onExited={onExited}
          dialogTitle={`${editActive ? "Update" : "Add"} User`}
          onSaveBtnClick={editActive ? onSaveEdit : onAddUser}
          saveBtnLabel={editActive ? "Update" : "Save"}
          saveBtnLoading={dialogBtnLoading}
        >
          <StandardOutlinedTextfield label="First Name" name="first_name" val={addUserData.first_name} setVal={setAddUserData} spreadData={addUserData} />
          <StandardOutlinedTextfield label="Phone Number" name="phone_no" type="number" val={addUserData.phone_no} setVal={setAddUserData} spreadData={addUserData} />
        </StandardMuiDialogWrapper>

        {/* Promote Class Dialog */}
        <StandardMuiDialogWrapper
          open={openPromoteDialog}
          setOpen={setOpenPromoteDialog}
          dialogTitle="Promote Class"
          onSaveBtnClick={onPromoteClass}
          saveBtnLabel="Promote"
          saveBtnLoading={promoteLoading}
        >
          <Typography sx={{ mb: 2, color: 'error.main' }}>
            This action will delete all pending users and all IDcards of this class? Do you want to Proceed?
          </Typography>
          <StandardOutlinedTextfield label="Standard" name="standard" val={promoteData.standard} setVal={setPromoteData} spreadData={promoteData} />
          <StandardOutlinedTextfield label="Division" name="division" val={promoteData.division} setVal={setPromoteData} spreadData={promoteData} />
        </StandardMuiDialogWrapper>

        {/* QR Code Dialog */}
        <Dialog open={qrOpen} onClose={() => setQrOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Teacher QR Code</DialogTitle>
          <DialogContent sx={{ padding: "20px" }}>
            {/* Step-1 */}
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
              Step-1:
            </Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              Download ID Solutions app on Playstore
            </Typography>
            <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
              OR
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Click this Link:{' '}
              <a
                href="https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#7978e9', textDecoration: 'none' }}
              >
                https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication
              </a>
            </Typography>

            {/* Step-2 */}
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
              Step-2:
            </Typography>
            <Typography variant="body1" sx={{ mb: 3 }}>
              Scan This QR For Login
            </Typography>

            {/* QR Code Display */}
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <div ref={qrRef}>
                {qrData ? (
                  <QRCodeCanvas value={qrData} size={220} includeMargin={true} />
                ) : (
                  <p>No QR Data</p>
                )}
              </div>
            </div>

            {/* Buttons */}
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                color="primary"
                onClick={downloadQRCode}
                startIcon={<Visibility />}
              >
                Download QR
              </Button>
              <Button
                variant="outlined"
                color="primary"
                onClick={copyQRCode}
                startIcon={<ContentCopy />}
              >
                Copy
              </Button>

              <Typography variant="body1" sx={{ mt: 3 }}>

                <a
                  href="https://gjaaipublication.com/login?con_mobile=7588811237 "
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#7978e9', textDecoration: 'none' }}
                >
                  https://gjaaipublication.com/login?con_mobile=7588811237
                </a>
              </Typography>
            </div>
          </DialogContent>
        </Dialog>
        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle sx={{ fontWeight: "bold", color: "error.main" }}>
            Delete User
          </DialogTitle>

          <DialogContent>
            <Typography>
              Are you sure you want to delete this user{" "}
              <strong>
                {deleteRowData?.first_name} ({deleteRowData?.phone_no})
              </strong>
              ?
            </Typography>

            <Typography sx={{ mt: 1, color: "text.secondary" }}>
              This action cannot be undone.
            </Typography>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              <Button
                variant="outlined"
                onClick={() => setOpenDeleteDialog(false)}
                disabled={deleteLoading}
              >
                Cancel
              </Button>

              <Button
                variant="contained"
                color="error"
                disabled={deleteLoading}
                onClick={(e) => {
                  onDelete(e, deleteRowData);
                  setOpenDeleteDialog(false);
                }}
              >
                {deleteLoading ? "Deleting..." : "Delete"}
              </Button>
            </div>
          </DialogContent>
        </Dialog>

      </StandardPageWrapper>
    </>
  );
}

export default User;

const tableColumns = [
  { label: 'School ID', key: 'schoolid', width: 75, fixed: true, align: 'center' },
  { label: 'Class ID', key: 'classid', width: 75, fixed: true, align: 'center' },
  { label: 'User ID', key: 'id', width: 100, fixed: true, align: 'center' },
  { label: 'First Name', key: 'first_name', minWidth: 150, flexGrow: 1, fullText: true },
  { label: 'Role', key: 'role', width: 100, fullText: true },
  { label: 'Phone Number', key: 'phone_no', width: 150 },
];
